import {
  convertTimeOffRequestEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime,
  convertTimeOffRequestSnapshotUTCIntegerFieldsToStationTimeZoneLuxonDateTime,
} from "./timeZoneService";

export const getScrubbedTimeOffRequestSnapshots = (timeOffRequestSnapshots) => {
  let scrubbedTimeOffRequestSnapshots = [];

  for (let i = 0; i < timeOffRequestSnapshots.length; i++) {
    scrubbedTimeOffRequestSnapshots.push(getScrubbedTimeOffRequestSnapshot(timeOffRequestSnapshots[i]));
  }

  return scrubbedTimeOffRequestSnapshots;
};

export const getScrubbedTimeOffRequestSnapshot = (timeOffRequestSnapshot) => {
  let scrubbedTimeOffRequestSnapshot = JSON.parse(JSON.stringify(timeOffRequestSnapshot));
  scrubbedTimeOffRequestSnapshot =
    convertTimeOffRequestSnapshotUTCIntegerFieldsToStationTimeZoneLuxonDateTime(scrubbedTimeOffRequestSnapshot);
  scrubbedTimeOffRequestSnapshot.id = scrubbedTimeOffRequestSnapshot.torId;

  return scrubbedTimeOffRequestSnapshot;
};

export const getScrubbedTimeOffRequestEvents = (timeOffRequestEvents) => {
  let scrubbedTimeOffRequestEvents = [];

  for (let i = 0; i < timeOffRequestEvents.length; i++) {
    let timeOffRequestEvent = JSON.parse(JSON.stringify(timeOffRequestEvents[i]));
    timeOffRequestEvent = convertTimeOffRequestEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime(timeOffRequestEvent);
    scrubbedTimeOffRequestEvents.push(timeOffRequestEvent);
  }

  return scrubbedTimeOffRequestEvents;
};

export const convertIncomingTorEventToSnapshotFormat = (timeOffRequestEvent) => {
  let eventInSnapshotFormat = {
    id: timeOffRequestEvent.torId,
    torId: timeOffRequestEvent.torId,
    station: timeOffRequestEvent.station,
    empFirstName: timeOffRequestEvent.requestingEmployeeFirstName,
    empId: timeOffRequestEvent.requestingEmployeeId,
    empLastName: timeOffRequestEvent.requestingEmployeeLastName,
    empWorkgroup: timeOffRequestEvent.requestingEmployeeWorkgroup,
    lastUpdatedDate: timeOffRequestEvent.createdAt,
    referenceNumber: timeOffRequestEvent.referenceNumber,
    shiftEnd: timeOffRequestEvent.shiftEnd,
    shiftStart: timeOffRequestEvent.shiftStart,
    status: timeOffRequestEvent.timeOffRequestStatus,
    submissionId: timeOffRequestEvent.submissionId,
    timeOffRequestType: timeOffRequestEvent.timeOffRequestType,
    visibleStatus: timeOffRequestEvent.visibleTimeOffRequestStatus,
    workgroup: timeOffRequestEvent.workgroup,
    wopASAP: timeOffRequestEvent.wopASAP,
    preferredWOPStart: timeOffRequestEvent.preferredWOPStart,
    preferredWOPEnd: timeOffRequestEvent.preferredWOPEnd,
    approvedWOPStart: timeOffRequestEvent.approvedWOPStart,
    approvedWOPEnd: timeOffRequestEvent.approvedWOPEnd,
    phoneNumber: timeOffRequestEvent.phoneNumber,
  };
  eventInSnapshotFormat =
    convertTimeOffRequestSnapshotUTCIntegerFieldsToStationTimeZoneLuxonDateTime(eventInSnapshotFormat);
  return eventInSnapshotFormat;
};
